const centrifugeBlue = '#2762ff';
const altairYellow = '#ffc012';
export const brandCentrifuge = {
    accentPrimary: centrifugeBlue,
    accentSecondary: altairYellow,
};
